import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Input from "components/Elements/Input";
import Select from "components/Elements/Select";
import { saveUser } from "actions/users";
import styled from "styled-components";
import { clearSavedUser } from "actions/users";

export const ErrorField = styled.span`
    color: red;
    font-size: 0.75rem;
    margin-top: 0.25rem;
`;

const AddUserModal = NiceModal.create(({user={}}) => {
  const dispatch = useDispatch();
  const { savedUser, saving, userTypes } = useSelector((state) => state.users);
  const modal = useModal();
  
  const hide = (e) => {
    e.stopPropagation();
    dispatch(clearSavedUser());
    modal.remove();
  };
  
  const cloneUser = (user) => {
    const u = {
        id: '',
        public_id: '',
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        user_type: '',
    };
    Object.keys(user).forEach((key) => {
        u[key] = user[key];
    }); 
    return u;
   }

  const [formErrors, setFormErrors] = useState({});
  const [localUser, setLocalUser] = useState(cloneUser(user));

  useEffect(() => {
    console.log("SAVED USER: ", savedUser);
    if(savedUser) {
        setLocalUser(cloneUser(savedUser));
    }
    }, [savedUser]); 


  const handleChange = ({target}) => {
    const u = {...localUser};
    u[target.name] = target.value;
    setLocalUser(u);
  }

  const handleUserTypeChange = (userType) => {
    const u = {...localUser};
    u.user_type = userType;
    setLocalUser(u);
  }


  const validateFields = () => {
    setFormErrors({});
    const errors = {};

    console.log("localUser: ", localUser)
    const emailValid = localUser.email && localUser.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    errors.email = emailValid ? '' : ' is invalid';
    const passwordValid = (localUser.public_id && localUser.password.length === 0) || (localUser.password && localUser.password.length >= 8);
    errors.password = passwordValid ? '': ' is too short';
    const firstNameValid = localUser.first_name && localUser.first_name.length > 0;
    errors.firstName = firstNameValid ? '': ' is required';
    const lastNameValid = localUser.last_name && localUser.last_name.length > 0;
    errors.lastName = lastNameValid ? '': ' is required';

    console.log("errors: ", errors);
    setFormErrors(errors);

    return emailValid && passwordValid && firstNameValid && lastNameValid;
  }

  const save = () => {
    console.log("save user: ", localUser)
    if(validateFields()) {
        dispatch(saveUser(localUser));
    }
  }

  return (
    <>
        <div
        className="w-6/12 force-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
        >
        <div className="relative w-full my-6 mx-auto max-w-3xl">
            {/*content*/}
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                <h3 className="text-3xl font-semibold">
                {user.id ? "Edit User" : "Add User"}
                </h3>
                <button
                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={hide}
                >
                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                    ×
                </span>
                </button>
            </div>
            {/*body*/}
            <div className="relative p-6 flex-auto ">
                <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <label>ID</label>
                <Input label="ID" placeholder="ID" name="id" value={localUser.id??""} disabled/>
                <label>Public ID</label>
                <Input label="Public ID" placeholder="Public ID" name="public_id" value={localUser.public_id??""} disabled/>
                <label>First Name <ErrorField>{formErrors.firstName}</ErrorField></label>
                <Input label="First Name" placeholder="First Name" name="first_name" value={localUser.first_name??""} onChange={handleChange}/>
                <label>Last Name <ErrorField>{formErrors.lastName}</ErrorField></label>
                <Input label="Last Name" placeholder="Last Name" name="last_name" value={localUser.last_name??""} onChange={handleChange}/>
                <label>Email <ErrorField>{formErrors.email}</ErrorField></label>
                <Input label="Email" placeholder="Email" name="email" value={localUser.email??""} onChange={handleChange} />
                <label>User Type <ErrorField>{formErrors.userType}</ErrorField></label>
                <Select label="User Type" placeholder="User Type" name="user_type" defaultValue={localUser.user_type??""} items={Object.values(userTypes).map(item => item.name)} onChange={handleUserTypeChange} />
                <label>Password <ErrorField>{formErrors.password}</ErrorField></label>
                <Input type="password" autoComplete="new-password" label="Password" name="password" placeholder="Password" value={localUser.password??""} onChange={handleChange}/>
                </div>
            </div>
            <div className="relative p-6 flex-auto">
                
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                {
                    !saving ? 
                        <button
                        className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                        type="button"
                        onClick={hide}
                        >
                        Close
                        </button> : null
                }
                <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={save}
                disabled={saving}
                >
                {
                    saving ? 
                        <><i className='fas fa-circle-notch fa-spin'></i> Saving...</>
                        : <>Save Changes</>
                }
                </button>
            </div>
            </div>
        </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    
    </>
  );
});

export default AddUserModal;